<div class="card card-stretch h-100 rounded-0 context-menu">


    <div class="row m-1">
        <div class="col-md-12">
            <div class="row mt-2">
                <div class="col-md-4">
                    <!--    <h5 class="d-inline font-weight-bolder">Applications</h5>-->
                    <div class="d-flex">
                        <div>
                            <img src="../../../../assets/common/images/new-dashboard/DashboardProductivity.svg" class="h-20px w-20px" />

                        </div>
                        <div class="pl-3">
                            <div class="font-weight-bolder h5">
                                {{'Productivity'|localize}}
                            </div>
                        </div>
                    </div>


                </div>
                <div class="col-md-4">
                    <!--    <h5 class="d-inline font-weight-bolder">Applications</h5>-->
                    <div class="d-flex">
                        <div>
                            <img src="../../../../assets/common/images/new-dashboard/DashboardCategory.svg" class="h-20px w-20px" />

                        </div>
                        <div class="pl-3">
                            <div class="font-weight-bolder h5">
                                {{'Category'|localize}}
                            </div>
                        </div>
                    </div>


                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex">
                                <div>
                                    <img src="../../../../assets/common/images/new-dashboard/Applications_Icon.svg" class="h-20px w-20px" />

                                </div>
                                <div class="pl-3">
                                    <div class="font-weight-bolder h5">
                                        {{'Application' |localize}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div *ngIf="!showEmptyScreenUI && applications?.length > 7" class="mt-1">
                                <div class="text-primary font-weight-bolder text-right cursor-pointer">
                                    <span (click)="viewAll()"> {{ 'ViewAll' | localize}}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!--    <h5 class="d-inline font-weight-bolder">Applications</h5>-->
                </div>
            </div>
        </div>

        <div class="col-md-8 " *ngIf="!showEmptyScreenUI">
            <div class="row">
                <div class="col-md-4 pt-1 m-0">
                    <div class="pies-container" id="pies-container1" style="width:304.5px;">

                        <dx-pie-chart *ngIf="areas && areas.length > 0" id="pie1" class="pie" [palette]="pieColorPalette" verticalAlignment="top" [dataSource]="areas" horizontalAlignment="right"
                                      (onPointHoverChanged)="onPointHoverChanged($event)" (onLegendClick)="legendClickHandler($event)" [resolveLabelOverlapping]="resolveOverlappingTypes[0]">

                            <dxi-series argumentField="appName" valueField="area" verticalAlignment="top" id="custom_graph">
                                <dxo-label [visible]="true" format="percent">
                                    <dxo-connector [visible]="false" [width]="0"> </dxo-connector>
                                </dxo-label>
                            </dxi-series>

                            <dxo-legend verticalAlignment="bottom"
                                        horizontalAlignment="center"
                                        itemTextPosition="right"
                                        [rowCount]="1">
                            </dxo-legend>
                            <dxo-size [width]="390"></dxo-size>
                            <dxo-export [enabled]="false"></dxo-export>
                            <dxo-tooltip [enabled]="true"
                                         format="currency"
                                         [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                        </dx-pie-chart>


                        <div class="center-circle" *ngIf="areas && areas.length > 0"></div>
                    </div>

                </div>
                <div class="col-md-6 ml-35 mt-1">
                    <div class="pies-container">
                        <dx-pie-chart *ngIf="prouctive" id="pie" class="pie" verticalAlignment="top" horizontalAlignment="center" palette="Soft Blue" [dataSource]="prouctive"
                                      (onPointHoverChanged)="onPointHoverChanged($event)" [customizePoint]="" #pieChart>
                            <dxo-common-annotation-settings type="image"
                                                            color="transparent"
                                                            [paddingLeftRight]="0"
                                                            [paddingTopBottom]="0"
                                                            tooltipTemplate="tooltipTemplate">
                                <dxo-image [height]="60"
                                           [width]="90"></dxo-image>
                                <dxo-border color="transparent"></dxo-border>
                            </dxo-common-annotation-settings>
                            <dxi-series argumentField="appName" valueField="area" [width]="300" label="flsldk">
                                <dxo-label [visible]="true" format="percent">
                                    <dxo-connector [visible]="true" [width]="0"></dxo-connector>
                                </dxo-label>
                            </dxi-series>
                            <dxo-legend verticalAlignment="bottom"
                                        horizontalAlignment="center"
                                        itemTextPosition="right"
                                        [rowCount]="2">
                            </dxo-legend>

                            <dxo-size [width]="400"></dxo-size>
                            <dxo-export [enabled]="false"></dxo-export>
                            <dxo-tooltip [enabled]="true"
                                         format="currency"
                                         [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                        </dx-pie-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8 pt-10" *ngIf="applications == null || undefined && !showEmptyScreenUI">
         <div class="row">
             <div class="col-md-6">
                 <ngx-shimmer-loading [width]="'260px'" [height]="'260px'" [shape]="'circle'"></ngx-shimmer-loading>

             </div>
             <div class="col-md-6">
                 <ngx-shimmer-loading [width]="'260px'" [height]="'260px'" [shape]="'circle'"></ngx-shimmer-loading>


             </div>

         </div>
        </div>

        <div class="col-md-4 pt-10" *ngIf="applications == null || undefined && !showEmptyScreenUI">
            <div class="card border mt-3" *ngFor="let app of [1,2,3,4,5,6,7]">
                <ngx-shimmer-loading [width]="'100%'" [height]="'30px'"></ngx-shimmer-loading>
            </div>
        </div>


        <div class="col-md-4" *ngIf="applications && !showEmptyScreenUI">
            <div class="card border mt-3" *ngFor="let app of applications | slice:0:7 index as i">
                <div *ngIf="i <= 7" class="card-body p-2" (onHidden)="removeData()" containerClass="popTemplateClass"
                     (onShown)="GetData(app.applicationName)" ngbPopover="dd" data-toggle="popover" container="body" placement="bottom"
                     data-trigger="hover" data-html="true" [popover]="popTemplate2" #popTemplate="bs-popover"
                     triggers="mouseenter:mouseleave">
                    <div class="row">
                        <div class="col-md-2">
                            <!-- <img src="{{app.icon ? app.icon : 'assets/common/images/timetracking/produactivity/inDesign.png'}}" class="h-30px" /> -->
                            <img *ngIf="!LoadingStarted || app.applicationName!=HistoryForApp" src="{{app.icon ? app.icon : 'assets/common/images/timetracking/produactivity/inDesign.png'}}"  id="myElement" />
                            <img *ngIf="LoadingStarted && app.applicationName==HistoryForApp" style="width: 25px;" src='assets/common/images/loading.gif'  id="myElement" />

                        </div>
                        <div class="col-md-5">
                            <div class="h6 mt-1">
                                <span pTooltip="{{ app.applicationName }}" [tooltipDisabled]="_tus.showTooltipForString(app.applicationName, 20)" tooltipPosition="bottom">{{app.applicationName | slice:0:20}} {{app.applicationName.length > 20 ? '...' : ''}}</span>
                                <!-- {{app.applicationName}} -->
                            </div>
                        </div>
                        <div class="col-md-5 text-md-right">
                            <small>

                                {{'TimeSpend' |localize}}: {{ timerToMinsHrsSecs(app.spendTime)}}
                            </small>
                        </div>
                    </div>
                </div>
                <ng-template #popTemplate2>
                    <div *ngIf="ShowDetails">
                        <div *ngFor="let app of HistoryDetails">
                            <div class="row">
                                <div class="col-md-10">
                                    <div class="h6">
                                         <span>{{app.windowName}}</span>
                                    </div>
                                </div>
                                <div class="col-md-2 d-flex pl-2">
                                    <small *ngIf="app.hours!=0">
                                        {{app.hours}}{{'h' | localize}}
                                    </small>
                                    <small *ngIf="app.minutes!=0">
                                        {{app.minutes}}{{'m' | localize}}
                                    </small>
                                    <small *ngIf="app.hours==0 && app.minutes==0">
                                        {{app.seconds}}{{'s' | localize}}
                                    </small>
                                </div>
                            </div>

                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <div *ngIf="showEmptyScreenUI" >

    <div class="d-flex flex-column justify-content-center">
        <div class="d-flex flex-column p-2">
            <img src="../../../../assets/common/images/time-off/empty-state-ui/my-time-off-empty-state.svg" class="p-2 ml-4 img-fluid h-250px" />
            <h6 class="text-muted mr-5 mt-4 text-center">{{'NoDataFounds' | localize}}</h6>
        </div>
    </div>
</div>


</div>


<!-- Export to PDF/Excel popup Modal -->
<div class="modal" id="myModal1">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header border-0">
                <button type="button" class="close pull-right text-danger ml-auto py-2" aria-label="Close" data-dismiss="modal">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>


            <!-- Modal body -->
            <div class="modal-body pt-0">
                <div class="col-md-12 text-center p-3">
                    <img src="../../../../assets/common/images/users/ExportImageforModal.svg" class="img-fluid" />
                </div>
                <div class="col-md-12 text-center mt-4 text-dark-65">
                    <h4>{{'SelectExportOption'|localize}}</h4>
                    <div class="font-size-sm text-muted">{{'ChooseanoptionfromExcelandPDFtoexport'| localize}}</div>
                </div>

                <!--<div class="col-md-12 kt-align-center mt-2"><label class="modal-text-header1">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat</label></div>-->
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-2"></div>
                    <div class="col-md-4"></div>
                </div>

                <div class="row mt-4">
                    <div class="col-md-6 mt-2">
                        <div class="p-3 border border-primary rounded d-flex justify-content-start align-items-center">
                            <img src="assets/common/images/users/1200px-PDF_file_icon.svg@2x.png" alt="logo" class="h-30px" />
                            <a class="cursor-pointer blue" (click)="exportToPdf($event)">
                                <div class="ml-4">
                                    <div>{{'ExportToPDF'|localize}}</div>
                                    <small class="text-muted">{{'ClickToexportListPdf' | localize}}</small>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 mt-2">
                        <div class="p-3 border border-primary rounded d-flex justify-content-start align-items-center">
                            <img src="assets/common/images/users/1200px-Microsoft_Office_Excel_(2018–present).svg@2x.png" alt="logo" class="h-30px" />
                            <a class="cursor-pointer blue" (click)="exportToExcel($event)">
                                <div class="ml-4">
                                    <div>{{'ExportToExcel'|localize}}</div>
                                    <small class="text-muted">{{'ClickToexportListExcel'|localize}}</small>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
